/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since  2017.9.8
 */
import './polyfill/Tooltip';
import './polyfill/Renderer';
import './polyfill/L.CanvasLayer';
//
import "./polyfill/FeatureGroup";
//
// import 'leaflet-path-drag'; // 已包含在transform
import 'leaflet-path-transform';
import '@/handle/Transform';
//
import './polyfill/Editable';
// 涉及重写 Polyline 的 onAdd 和 flow 有顺序执行的冲突
// import '@/plugins/meature/leaflet-measure-path';
// import '@/plugins/meature/leaflet-measure-path.css';
// 聚合点
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import './polyfill/MarkerCluster';
// 添加shp文件
import './polyfill/Shp';
//
import './feature/CanvasTooltip';
import './feature/Mask';



// WEBPACK FOOTER //
// ./src/Polyfill.js